import React, { useContext, useState, useEffect, useRef } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link, useNavigate } from "react-router-dom";

//components
import MainScreenPages from "../../pages/MainScreen/MainScreen1";
import LockScreenPages from "../../pages/Misc/Lock";

//styles
import {
  BlueButton,
  ButtonContainer,
  SmartKeyButton,
  YellowButton,
} from "./Buttons.elements";

//images
import yb from "../../img/buttons/yb.png";
import bb from "../../img/buttons/bb.png";
import gb from "../../img/buttons/gb.png";

const Buttons = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(AppContext);
  const buttonPressTimeoutRef = useRef(null);

  const handleMouseDown = () => {
    buttonPressTimeoutRef.current = setTimeout(() => {
      setState((prevState) => ({ ...prevState, isButtonPressed: true }));

 

      setState((prevState) => ({
        ...prevState,
        lockScreenIndex:
          (prevState.lockScreenIndex + 1) % LockScreenPages.length,
      }));
    }, 1500);
  };

  const handleMouseUp = () => {


    {
      state.isButtonPressed &&
        setState((prevState) => ({
          ...prevState,
          isLocked: true,
          
        }));

        navigate("/");

    }
    clearTimeout(buttonPressTimeoutRef.current);
  };

  const handleClick = () => {
    if (state.standBy === true) {
      setState((prevState) => ({
        ...prevState,
        blankScreen: true,
        standBy: false,
      }));
    } else if (!state.isButtonPressed && !state.isLocked) {
      setState((prevState) => ({
        ...prevState,
        currentPageIndex:
          (prevState.currentPageIndex + 1) % MainScreenPages.length,
        disableChangeNumeric: false,
      }));
    } else if (state.isLocked) {
      setState((prevState) => ({ ...prevState, currentPageIndex: 0 }));
    }
  };



  function acknowledgeAlarms() {
    if (!state.alarmsPause && state.initiateAlarms)
      setState((prevState) => ({
        ...prevState,
        acknowledgeAlarms: !prevState.acknowledgeAlarms,
      }));
  }

  useEffect(() => {
    if (state.acknowledgeAlarms === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          initiateAlarms: false,
          startInitiateAlarms: false,
          xTachyAlarmAlert: false,
          acknowledgeAlarms: false,
        }));
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [state.acknowledgeAlarms]);

  return (
    <ButtonContainer>
      <YellowButton
        src={yb}
        onClick={acknowledgeAlarms}
        disabled={state.alarmsPause || state.initiateAlarms === false}
      ></YellowButton>

      <Link to="/settings">
        <SmartKeyButton src={gb}></SmartKeyButton>
      </Link>

    

      <div
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onClick={handleClick}
        onTouchStart={handleMouseDown}
        onTouchEnd={handleMouseUp}
        style={{ position: "relative", cursor:"pointer" }}
        className="noselect"
      >
        <BlueButton src={bb}></BlueButton>
        <div
          style={{
            position: "absolute",
            top: "0",
            width: "100%",
            height: "100%",
          }}
        ></div>
      </div>
    </ButtonContainer>
  );
};

export default Buttons;
